import {register} from '@shopify/theme-sections';

import renderProductCard from '../components/product-card-template';

const selectors = {
  widget: '[data-widget="recommendations"]',
};

export default register('tagalys-recommendations', {
  onLoad() {
    const container = this.container;
    const widgetElem = container.querySelector(selectors.widget);

    if (!widgetElem) return;

    const widgetSettingsAttr = widgetElem.dataset.widgetSettings || '{}';
    const widgetSettings = JSON.parse(widgetSettingsAttr);
    const productId = widgetSettings.productId;
    const recommendationId = widgetSettings.recommendationId;

    if (!productId || !recommendationId) return;

    window.Tagalys.UIWidgets.Recommendations.init(selectors.widget, {
      recommendationId: recommendationId,
      productId: productId,
      templates: {
        widget: {
          labels: {
            heading: widgetSettings.title,
          },
          options: {
            limit: 8,
            displayFormat: 'carousel',
            includeTagalysCSS: false,
            carouselOptions: {
              perPage: {
                300: 2,
                768: 3,
                1280: 4,
              },
            },
          },

          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const products = helpers.getProducts();

            if (props.loading === false) {
              if (products.length === 0) {
                return null;
              }
              return html`
                <div class="container">
                  <${args.templates.header} />
                  <${args.templates.productList} />
                </div>
              `;
            }
          },
        },
        header: {
          render: function (html, args) {
            return html` <h2 class="product-recommendations__heading">${args.labels.heading}</h2> `;
          },
        },
        products: {
          render: function (html, args) {
            const props = args.props;
            const products = props.helpers.getProducts();

            return html`
              <div class="products products-carousel">
                ${products.map((product, index) => {
                  return html` <${args.templates.product} key=${index} product=${product} /> `;
                })}
              </div>
            `;
          },
          callbacks: {
            afterEveryRender: function () {
              document.dispatchEvent(new CustomEvent('results-grid:loaded'));
            },
          },
        },
        product: {
          render: function (html, args) {
            const props = args.props;
            const product = props.product;
            const helpers = props.helpers;

            return html`<div dangerouslySetInnerHTML=${{__html: renderProductCard(product, helpers)}} />`;
          },
        },
        carouselActions: {
          render: function (html, args) {
            const props = args.props;

            return html`
              <button
                class="products-carousel__btn products-carousel__prev"
                disabled=${props.helpers.carousel.isFirstSlide()}
                onClick=${props.helpers.carousel.goLeft}
              >
                <svg
                  aria-label="Chevron left icon"
                  class="icon icon-chevron-left"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m14 18-6-6 6-6"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="square"
                    vector-effect="non-scaling-stroke"
                  />
                </svg>
              </button>

              <button
                class="products-carousel__btn products-carousel__next"
                disabled=${props.helpers.carousel.isLastSlide()}
                onClick=${props.helpers.carousel.goRight}
              >
                <svg
                  aria-label="Chevron right icon"
                  class="icon icon-chevron-right"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m10 18 6-6-6-6"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="square"
                    vector-effect="non-scaling-stroke"
                  />
                </svg>
              </button>
            `;
          },
        },
      },
      callbacks: {
        onSuccessfulAPICall: async (response) => {
          const staticTranslations = {};
          const translatedResponse = await TagalysMarketTranslations.translate(response, staticTranslations);
          return translatedResponse;
        },
      },
    });
  },
});
